<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span(v-if="perfilUsuario === 'recursos humanos'") Solicitudes de vacaciones
      span(v-else) Solicitudes de vacaciones de mi equipo
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret(@click="mostrarFiltros = !mostrarFiltros")
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)

          .filtros(v-if="mostrarFiltros", key="filtros")
            .filtro(v-if="perfilUsuario === 'recursos humanos'")
              .title-singular
                p Estado
              .select.display-flex
                select.flex-1(v-model='filtroEstado')
                  option(value="all") Todos
                  option(:value="+key", v-for="(value, key) in estados") {{value.descripcion}}

            .filtro
              .codigo-empleado
                .control.title-singular
                  p Empleado
                  .input-container
                    input.input(
                      type="number",
                      v-model="filtroCodigoEmpleado"
                    )
                    span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                      i.fa.fa-search
                    .erase-data(@click="limpiarEmpleado")
                      .icon
                        .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaEmpleado"
                    )
                      lookup-small-empleado(
                        @selected="seleccionarEmpleado"
                        @close="mostrarBusquedaEmpleado = false"
                        :codigo="filtroCodigoEmpleado"
                      )

            .filtro
              .title-singular
                p Mes
                .select.display-flex
                  select.flex-1(v-model='filtroMes')
                    option(:value="o.codigo", v-for="o in meses") {{o.codigo === 'all' ? 'Todos' : o.descripcion}}


            .filtro
              .title-singular
                p Año
                .select.display-flex
                  select.flex-1(v-model='filtroYear')
                    option(:value="o", v-for="o in years") {{o === 'all' ? 'Todos' : o}}



          .boton-container(key="boton-container")
            button.button(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar


      div(
        key="body-scroll"
        v-infinite-scroll="fetchByScroll"
        infinite-scroll-disabled="disabledScrollExecute"
        infinite-scroll-distance="2"
      )
        .body(key="body")
          .information
            transition(
              name='fade',
              tag="div",
              v-if="mostrarConfirmacionNoLoTomo"
              )
              confirmar-accion-overlay(
                @close="mostrarConfirmacionNoLoTomo = false"
                @do="noLoTomo"
                ref="confirmarNoLoTomo"
              )
                span(slot="title") ¿Desea indicar que la solicitud no se tomó?
                span(slot="primaryAction")
                  template(v-if="isSending")
                    span.icon
                      i.fa.fa-spinner.fa-spin
                  template(v-else)
                    span No lo tomó
          table.table.is-striped.is-bordered(
            v-if="solicitudes.length !== 0"
          )
            thead
              //- th Id
              th Empleado
              th Fecha
              th.hide-break-1 Retorno
              th Estado
              th Reemplazante
              th.hide-break-2(v-if="perfilUsuario === 'recursos humanos'")
            tbody(
              name="table-row"
              is="transition-group"
            )
              tr.row-table(
                v-for="o in solicitudes"
                :key="o.id"
                :class="{ 'is-close': !o.abierto }"
              )

                td
                  .hint--bottom(:aria-label="'Solicitud: ' + o.id")
                    span.hint--top(:aria-label="'Empleado: ' + o.dniEmpleado") {{ o.nombreEmpleado }}
                td
                  .td-wrapper
                    .dates-wrapper
                      span {{ o.desde }}
                      template(v-if="o.desde !== o.hasta")
                        span.hide-break-1 &nbsp;-&nbsp;
                        span {{ o.hasta }}
                    div.show-break-1.dates-wrapper
                      span.has-text-bold Retorno:
                      span {{ o.retorno }}
                      span.dias ({{ o.dias }} días)
                td.hide-break-1
                  .td-wrapper
                    span {{ o.retorno }}&nbsp;
                    span.dias ({{ o.dias }} días)
                td {{ o.estadoData.descripcion }}
                td
                  template(v-if="o.codigoEmpleadoReemplazante")
                    span.hint--top(:aria-label="'Reemplazante: ' + o.dniReemplazante")
                      | {{ o.nombreEmpleadoReemplazante }}
                  template(v-else)
                    span No definido
                  .contenedor-acciones.show-break-2(v-if="perfilUsuario === 'recursos humanos'")
                    button.button.is-small.is-danger(@click="confirmarNoLoTomo(o)", v-if="o.estado === 3")
                      span No lo tomó
                td.hide-break-2(v-if="perfilUsuario === 'recursos humanos'")
                  button.button.is-small.is-danger(
                    @click="confirmarNoLoTomo(o)"
                    v-if="o.estado === 3"
                  )
                    span.icon.is-small
                      i.fa.fa-times
                    span No lo tomó
          loading(v-if="isLoading")
          div(v-if="solicitudes.length === 0 && !isLoading")
            .message.is-warning
              .message-body No hay solicitudes de vacaciones que cumplan con los siguientes filtros
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'
import { apiGet, apiPut, notify } from '../util/general'
import { scrollTo } from '../util/scroll'
import moment from 'moment'
export default {
  name: 'lista_solicitud_vacaciones_component',
  data () {
    return {
      perfilUsuario               : localStorage.getItem('perfilVacaciones'),
      solicitudes                 : [],
      isLoading                   : false,
      isSending                   : false,
      mostrarBusquedaEmpleado     : false,
      mostrarFiltros              : true,
      mostrarConfirmacionNoLoTomo : false,
      solicitudSeleccionada       : {},
      filtroCodigoEmpleado        : '',
      filtroEstado                : 3,
      filtroMes                   : 'all',
      filtroYear                  : moment().format('YYYY'),
      estados                     : {},
      meses                : [
        { codigo: 'all', descripcion: 'Todos' },
        { codigo: 1, descripcion: 'Enero' },
        { codigo: 2, descripcion: 'Febrero' },
        { codigo: 3, descripcion: 'Marzo' },
        { codigo: 4, descripcion: 'Abril' },
        { codigo: 5, descripcion: 'Mayo' },
        { codigo: 6, descripcion: 'Junio' },
        { codigo: 7, descripcion: 'Julio' },
        { codigo: 8, descripcion: 'Agosto' },
        { codigo: 9, descripcion: 'Setiembre' },
        { codigo: 10, descripcion: 'Octubre' },
        { codigo: 11, descripcion: 'Noviembre' },
        { codigo: 12, descripcion: 'Diciembre' }
      ],
      years: [
        'all',
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024,
        2025,
        2026
      ],
      disabledScrollExecute: false,
      isScroll: false,
      noMore  : false,
      skip:     0
    }
  },
  components: {
    LookupSmallEmpleado,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  created () {
    this.limpiarFiltros()
    this.fetchEstados()
    this.fetch()
  },
  watch : {
    filtroCodigoEmpleado (value) {
      return this.fetch()
    },
    filtroEstado (value) {
      return this.fetch()
    },
    filtroMes (value) {
      return this.fetch()
    },
    filtroYear (value) {
      return this.fetch()
    }
  },
  methods: {
    fetchEstados () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/vacaciones/estado', obj, function (data) {
        vm.estados = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    fetch () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true

      vm.disabledScrollExecute = true
      vm.noMore = false
      var filtros = {
        codigoEmpleado : vm.filtroCodigoEmpleado,
        estado         : vm.filtroEstado,
        mes            : vm.filtroMes,
        year           : vm.filtroYear
      }

      var obj = {
        filtros: filtros
      }
      if (!vm.isScroll) {
        vm.solicitudes = []
        vm.skip = 0
      }
      obj.skip = vm.skip
      apiGet(vm, '/vacaciones/solicitud/reporte', obj, function (data) {
        data.lista.forEach(function (o) {
          vm.solicitudes.push(o)
        })
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
        // esto replica la lista 3 veces
        // vm.solicitudes.push(...data.lista.map(obj => ({...obj, id: obj.id + 200})));
        // vm.solicitudes.push(...data.lista.map(obj => ({...obj, id: obj.id + 300})));
        // vm.solicitudes.push(...data.lista.map(obj => ({...obj, id: obj.id + 400})));
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtroCodigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtroEstado = 3
      this.filtroCodigoEmpleado = ''
      this.filtroMes = 'all'
      this.filtroYear = moment().format('YYYY')
    },
    confirmarNoLoTomo (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionNoLoTomo = true
      this.$nextTick(function () {
        scrollTo({
          vm: this,
          ref: this.$refs.confirmarNoLoTomo.$el,
          mobile: -20,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    noLoTomo () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: this.solicitudSeleccionada.id
      }

      apiPut(vm, '/vacaciones/empleado/solicitud/nolotomo', obj, function (data) {
        vm.mostrarConfirmacionNoLoTomo = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    },
    limpiarEmpleado () {
      this.filtroCodigoEmpleado = ''
      this.fetch()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }
  .contenedor-acciones
    display flex
    .button
      flex 1
      margin 0px 5px
      i
        margin-left 2px
        font-size 15px
  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  td
    vertical-align: middle;
  .dias
    font-size 12px
    color #9a9a9a

  is-close
    background-color: #ffd6d6 !important;

  .show-break-1
    display none
  .show-break-2
    display none
  // .td-wrapper
  //     display flex
  //     justify-content: center
  //     align-items: center
  //     flex-direction: column
  @media (max-width 1095px)
    .filtros-container
      .filtros
        flex-direction: column
        .filtro
          width 100%
  @media (max-width 932px)
    .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column
  @media (max-width 660px)
    .show-break-2
      display initial
    .hide-break-2
      display none
    .contenedor-acciones
      display flex
      flex-direction: column
      gap: 10px
      margin-top 10px
  @media (max-width 583px)
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column


    .show-break-1
      display initial

    .hide-break-1
      display none

  @media (max-width 403px)
    .table
        font-size 11px

</style>



// WEBPACK FOOTER //
// Component_Reporte_Lista_Solicitud_Vacaciones.vue?4c73aac0